import axiosInstance from "../../../../services/api.service";
import constants from '../../../../constants/constants'

export const LOGIN_URL = "Users/Authenticate";
export const REGISTER_URL = "auth/register";
export const REQUEST_PASSWORD_URL = "auth/forgot-password";

export const ME_URL = "me";

export function login(user) {
  return axiosInstance.post(LOGIN_URL, user, {
    requestHandlerEnabled: false,
    responseHandlerEnabled: true
  });
}

export function register(email, fullname, username, password) {
  return axiosInstance.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axiosInstance.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axiosInstance.get(ME_URL);
}
